import {
  IconSocialFacebookDefault,
  IconSocialPinterestDefault,
  IconSocialTwitterDefault,
} from '@mc/design-system'
import {
  facebookSharePath,
  pinterestSharePath,
  twitterSharePath,
} from '../paths'

export const getSocialLinks = (image, title, urlToShare) => [
  {
    name: 'twitter',
    icon: <IconSocialTwitterDefault />,
    linkPath: twitterSharePath(title, urlToShare),
  },
  {
    name: 'facebook',
    icon: <IconSocialFacebookDefault />,
    linkPath: facebookSharePath(urlToShare),
  },
  {
    name: 'pinterest',
    icon: <IconSocialPinterestDefault />,
    linkPath: pinterestSharePath(urlToShare, image, title),
  },
]
